import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
  beforeLoad: () => {
    const isLoggedIn = useAuthStore.getState().isLoggedIn
    if (!isLoggedIn) {
      throw redirect({
        to: '/sign-in',
      })
    }
  },
})
